import { useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { useTheme } from "../../context/ThemeContext";


const Racing = () => {
  const { themeColors } = useTheme();
  const isSmallScreen = window.innerWidth <= 768;

  const raceData = {
    races: [
      {
        type: "Horse Racing",
        image: "assets/images/horse-login.svg",
        backgroundColor: 'var(--dark-theme-time-remaining)',
        items: [
          { location: "Canterbury (AUS)", date: "9th Jun", time: "10:06" },
          { location: "Randwick (AUS)", date: "9th Jun", time: "11:30" },
          { location: "Rosehill (AUS)", date: "9th Jun", time: "12:00" },
          { location: "Rosehill (AUS)", date: "9th Jun", time: "12:00" },
          { location: "Rosehill (AUS)", date: "9th Jun", time: "12:00" }
        ]
      },
      {
        type: "Greyhound Racing",
        image: "assets/images/dog-login.svg",
        backgroundColor: 'var(--dark-theme-time-remaining)',
        items: [
          { location: "Melbourne (AUS)", date: "9th Jun", time: "09:45" },
          { location: "Sydney (AUS)", date: "9th Jun", time: "10:15" },
          { location: "Brisbane (AUS)", date: "9th Jun", time: "10:45" },
          { location: "Brisbane (AUS)", date: "9th Jun", time: "10:45" },
          { location: "Brisbane (AUS)", date: "9th Jun", time: "10:45" }
        ]
      }
    ]
  };
  const styles = {
    row: {
      display: 'flex',
      overflowX: 'auto',
    },
    raceText: {
      color: 'var(--dark-theme-white-color)',
      cursor: 'pointer',
      transition: 'color 0.3s',
    },
    raceTextHover: {
      color: 'var(--dark-theme-time-remaining)'
    }
  };


  return (
    <>
      {raceData.races.map((race, i) => (
        <div key={i}>
          <div style={{ backgroundColor: race.backgroundColor }}>
            <h6 className="mb-0 fw-bold py-1 ps-2">{race.type}</h6>
          </div>
          <div className='container-fluid p-0 m-0' style={{ backgroundColor: 'var(--dark-theme-data-bg)' }}>
            <div className='gap-3' style={styles.row}>
              {race.items.map((item, index) => (
                <div className='col-lg-2 col-6 mb-0' key={index}>
                  <div className='row'>
                    <div className='col-lg-3 col-3 mb-0 p-0'>
                      <img src={race.image} className='img-fluid' alt={race.type} />
                    </div>
                    <div className='col-lg-9 col-9 mb-0 text-center p-0'>
                      <a
                        href="#"
                        className="fw-bold"
                        style={styles.raceText}
                        onMouseEnter={(e) =>
                        (e.currentTarget.style.color =
                          "var(--dark-theme-time-remaining)")
                        }
                        onMouseLeave={(e) =>
                        (e.currentTarget.style.color =
                          "var(--dark-theme-white-color)")
                        }
                      >
                        {item.location} {item.date} {item.time}
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default Racing;
